import Styles from './Loader.module.scss'

export const Loader = () => <div className={Styles.loader} role="progressbar" aria-busy="true" aria-live="polite" />
